export class Commande {

    id: number;
    typeCommande: string;
    referenceOracle: string;
    agent: string;
    codePartenaire: string;
    dateCommande: any;
    piecesJointes: string;
    montant: number;
    etatAdv: boolean;
    etatTresorerie: boolean;
    etatComptabilite: boolean;
    etatSupport: boolean;
    etatDAL: boolean;
    etatResponsableOmy: boolean;
    etatChefTresorOmy: boolean;
    etatLivraison: string;
    statut: boolean;
    etat: string;
    meta: string;
    listProduit: any;
    bordereaux: any;
    pieces: any;
    idWorkflow: number;
    devise: string;
    tauxEchange:number;

    commentaireRejetAdv : string;
    commentaireRejetTreso : string;
    commentaireRejetSupport : string;

    constructor() { }
}
